<div class="card block isMinimizable">
    <div class="card-header">
        <div class="card-title">
            <h6>Total des travaux
                <p class="value">{{ favorite.works_total + favorite.works_not_deduc + favorite.other_fees_work | number:'1.0-0' }} €</p>
            </h6>
            <i class="fa fa-angle-up"></i>
            <h2>Travaux</h2>
        </div>
    </div>
    <div class="card-body col-12">
        <img *ngIf="preview" src="assets/widgets/travaux.PNG" class="img-fluid"/>
        <div class="card-text row" *ngIf="!preview">
            <div *ngIf="user.pro_plan != '' || favorite.other_fees_work > 0" class="col-12">
                <mat-form-field>
                    <mat-label>Architecte / Maitrise d'oeuvre</mat-label>
                    <input matInput [(ngModel)]="favorite.other_fees_work" (ngModelChange)="edit($event, -1)">
                    <span matSuffix>€</span>
                </mat-form-field>
            </div>
            <div class="col-12" *ngFor="let lot of favorite.lots; index as i">
                <div class="bg-light p-3 pb-0 rounded mb-3">
                    <div class="row">
                        <h3 class="col-12 mt-0">
                            {{ lot.title != '' ? lot.title : "Lot " + i }}
                            <span>{{ lot.estate_type }} de {{ lot.square }} m²
                                <ng-container *ngIf="lot.rooms > 0 && (lot.estate_type == 'Maison' || lot.estate_type == 'Appartement')"> - {{ lot.rooms }} pièces</ng-container></span>
                        </h3>

                        <div class="col-md-4 col-12">
                            <mat-form-field>
                                <mat-label>Travaux envisagés</mat-label>
                                <mat-select disableOptionCentering [(ngModel)]="lot.works_help"
                                            (ngModelChange)="edit($event, i, 'works_help')">
                                    <mat-option [value]="0">Aucun travaux</mat-option>
                                    <mat-option [value]="this.user.work_1">Rafraichissement ({{ this.user.work_1 }}€/m²)
                                    </mat-option>
                                    <mat-option [value]="this.user.work_2">Renovation ({{ this.user.work_2 }}€/m²)
                                    </mat-option>
                                    <mat-option [value]="this.user.work_3">Remise a neuf ({{ this.user.work_3 }}€/m²)
                                    </mat-option>
                                    <mat-option [value]="-1">Personnaliser</mat-option>
                                </mat-select>
                            </mat-form-field>
                        </div>
                        <div class="col-md-4 col-6">
                            <mat-form-field>
                                <mat-label>Ratio</mat-label>
                                <input type="number" step="10" matInput [(ngModel)]="lot.works_square_price"
                                       (ngModelChange)="edit($event, i,'works_square_price')"
                                       [disabled]="lot.works_help != -1">
                                <span matSuffix>€/m²</span>
                            </mat-form-field>
                        </div>
                        <div class="col-md-4 col-6">
                            <mat-form-field>
                                <mat-label>Montant total des travaux</mat-label>
                                <input type="number" step="100" matInput [(ngModel)]="lot.works_total"
                                       (ngModelChange)="edit($event, i,'works_total')"
                                       [disabled]="lot.works_help != -1">
                                <span matSuffix>€</span>
                            </mat-form-field>
                        </div>

                        <div class="col-4" *ngIf="user.pro_plan == 'oikos'">
                            <mat-form-field>
                                <mat-label>Menuiseries</mat-label>
                                <input class="text" matInput [(ngModel)]="lot.window"
                                       (ngModelChange)="edit($event, i, 'window')">
                            </mat-form-field>
                        </div>

                        <div class="col-4" *ngIf="user.pro_plan == 'oikos'">
                            <mat-form-field>
                                <mat-label>Chauffage</mat-label>
                                <input class="text" matInput [(ngModel)]="lot.heating"
                                       (ngModelChange)="edit($event, i, 'heating')">
                            </mat-form-field>
                        </div>

                        <div class="col-4" *ngIf="user.pro_plan == 'oikos'">
                            <mat-form-field>
                                <mat-label>DPE</mat-label>
                                <input class="text" matInput [(ngModel)]="lot.dpe"
                                       (ngModelChange)="edit($event, i, 'dpe')">
                            </mat-form-field>
                        </div>
                    </div>
                </div>
            </div>

            <div class="col-6">
                <mat-slide-toggle class="mt-3" color="primary" [(ngModel)]="favorite.works_deduc"
                                  (change)="edit($event, -1)">Ajouter des travaux non déductibles
                </mat-slide-toggle>
            </div>
            <ng-container *ngIf="favorite.works_deduc">
                <div class="col-6">
                    <mat-form-field>
                        <mat-label>Travaux non déductibles</mat-label>
                        <input matInput [(ngModel)]="favorite.works_not_deduc" (ngModelChange)="edit($event, -1)">
                        <span matSuffix>€</span>
                    </mat-form-field>
                </div>
            </ng-container>
        </div>
    </div>
</div>
